import React from 'react';
import SubscriptionContainer from '@src/containers/Subscription';

const Subscription = () => {
  const renderSubscriptionPage = () => <SubscriptionContainer />;

  return renderSubscriptionPage();
};

export default Subscription;
